let navigationWrapper = document.querySelector('[data-pageNavigation]');
let menuHeight = document.querySelector('.topBar').offsetHeight;

gsap.registerPlugin(ScrollTrigger);

function prepareDots() {
    let sections = document.querySelectorAll('[data-section]');
    if( sections ) {
        sections.forEach(function(item, i) {
            let dot = document.createElement('a');
                dot.classList.add('pageNavigation__dot');
                dot.innerHTML ='<span class="pageNavigation__dotLabel">'+ item.getAttribute('data-section') +'</span>';

                if( i == 0 ) {
                    dot.classList.add('pageNavigation__dot--active');
                }

            navigationWrapper.appendChild(dot);
        });
        setTimeout(function() {
            assignDotClickAction();
            assignDotActiveState();
        }, 10);
    }
}
function assignDotClickAction() {
    let dots = document.querySelectorAll('.pageNavigation__dot');

    if( dots.length ) {
        dots.forEach(function(dot, index) {
            let items = document.querySelectorAll('[data-section]');
            let item = items[index];
            dot.addEventListener('click', function(e) {
                e.preventDefault();
                gsap.to(window, { scrollTo: (item.offsetTop - menuHeight )});
            });
        })
    }
}
function assignDotActiveState() {
    let sections = document.querySelectorAll('[data-section]');
    sections.forEach(function(item, i) {
        ScrollTrigger.create({
            trigger: item,
            start: "top 250px",
            end: (i + 1) * innerHeight - innerHeight / 2,
            markers: false,
            onEnter: () => {
                let activeDot = document.querySelector('.pageNavigation__dot--active');
                if( activeDot ) {
                    activeDot.classList.remove('pageNavigation__dot--active');
                }

                document.querySelectorAll('.pageNavigation__dot')[i].classList.add('pageNavigation__dot--active');
            },
            onEnterBack: () => {
                let activeDot = document.querySelector('.pageNavigation__dot--active');
                let prevIndex = i > 0 ? i -1 : 0;
                if( activeDot ) {
                    activeDot.classList.remove('pageNavigation__dot--active');
                }

                document.querySelectorAll('.pageNavigation__dot')[prevIndex].classList.add('pageNavigation__dot--active');
            },
        })
    });
}

function scrollItems() {
    let buttons = document.querySelectorAll('.scrollBtn, .scroll-btn, .btn-scroll, .button--scroll');

    if( buttons ) {
        buttons.forEach(function(item) {
            let link = '';
            console.log('tag', item.tagName);
            if(item.tagName == 'A') {
                link = item;
            } else {
                link = item.querySelector('a');
            }

            link.addEventListener('click', function(e) {
                e.preventDefault();

                let target = document.querySelector(link.getAttribute('href')).offsetTop;
                gsap.to(window, { scrollTo: (target - menuHeight) });
            });
        });
    }
}


export { prepareDots }
export { assignDotClickAction }
export { assignDotActiveState }
export { scrollItems }


//////////////////
// WEBPACK FOOTER
// ./js/modules/pageNavigation.js
// module id = 3
// module chunks = 0